<template>
    <div class="project-box">
        <div class="project-head">
        <div class="project-title">
             <div class="row">
                <div class="col-md-2 text-center">
                    <div class="avatar-w">
                        <img alt="" class="img-fluid" 
                                    :src="`${baseUrl}/redeImagem/${redeExames.rede._id}/logo`" 
                                    :onerror="`this.src='${require('@/img/icon-drachei-alpha.svg')}'`">
                    </div>
                </div>
                <div class="col-md-10">
                    <h5>{{redeExames.rede.nomeRede}}</h5>
                    <small>{{endereco}}</small>
                    <div>
                    <rate :length="5" :value="redeExames.rede.rate" :readonly="true" ></rate> 
                    </div>
                    <div>
                      <a v-if="redeExames.rede.coletaDomiciliar" href="#" class="badge badge-primary mr-sm-2">Coleta Em Domicílio</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="project-users">
            <a class="mr-2 btn btn-sm btn-outline-info" :data-target="`#onboardingFeaturesModal-${index}`" data-toggle="modal"><span>Ver detalhes</span></a>
            <div aria-hidden="true" class="onboarding-modal modal fade animated" :id="`onboardingFeaturesModal-${index}`" role="dialog" tabindex="-1">
                <div class="modal-dialog modal-centered" role="document">
                <div class="modal-content text-center">
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span class="close-label">Fechar</span><span class="os-icon os-icon-close"></span></button>
                    
                    <div class="onboarding-content with-gradient">
                      <div class="alert alert-info" role="alert">
                        <strong>Confira que o(s) nome(s) do(s) exame(s) escolhido(s) esta(ão) de acordo com o pedido médico!</strong>
                      </div>
                    <h4 class="onboarding-title">
                        Detalhes dos valores
                    </h4>
                    <div class="row">
                        <div class="col">
                            <table class="table table-lightborder">
                          <thead>
                            <tr>
                              <th>Descrição do exame</th>
                              <th>Particular</th>
                              <th>Dr.Achei</th>
                              <th>Dr.Achei Card</th>

                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="exame in redeExames.exames" :key="exame._id">
                              <td>{{exame.nomeExame}}</td>
                              <td>{{exame.valorParticular || 0.0 | money}}</td>
                              <td>{{(exame.valorDrAchei || 0.0) | money}}</td>
                              <td>{{exame.valorSinSaude || 0.0 | money}}</td>
                            </tr>
                          </tbody>
                        </table>
                        </div>
                    </div>
                    <div class="row" v-if="`onboardingFeaturesModal-${index}` === idModalCompra">
                      <div class="col">
                        <button type="button" @click.stop="comprar()" class="btn btn-primary btn-lg btn-block">
                          Adquirir
                          </button>
                      </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <!-- ao clicar em comprar exibir modal de detalhe com o alerta para conferir a descricao com o pedido medico
             e confirmando levar para pagina de compra. -->
            <button class="btn btn-lg btn-primary" @click="modalComprar(`onboardingFeaturesModal-${index}`)" > Comprar</button>
        </div>
        </div>
        <div class="project-info">
        <div class="row align-items-center">
            
            <div class="col-sm-9">
            <div class="label mb-3">
                Valor Total dos exames
            </div>
            <div class="row">
                <div class="col-md-4 col-sm-12">
                <div class="el-tablo highlight">
                    <div class="label">Particular</div>
                    <div class="value">{{(redeExames.subTotalParticular||0.0) | money}}</div>
                </div>
                </div>
                <div class="col-md-4 col-sm-12">
                <div class="el-tablo highlight">
                    <div class="label">Dr.Achei</div>
                    <div class="value">{{(redeExames.subTotalDrachei||0.0) | money}}</div>
                </div>
                </div>
                <div class="col-md-4 col-sm-12">
                <div class="el-tablo highlight">
                    <div class="label">Dr.Achei Card</div>
                    <div class="value">{{(redeExames.subTotalSinSaude||0.0) | money}}</div>
                </div>
                </div>
            </div>
            
            </div>
            <div class="col">
            
            </div>
        </div>
        </div>
    </div>
</template>
<script>
import http from 'axios'

export default {
  props: {
    redeExames: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      subTotalSinSaude: 0.0,
      idModalCompra: null
    }
  },
  computed: {
    endereco () {
      let unidade = this.redeExames.rede
      return `${unidade.localAtendimento}, numero ${unidade.numero}, ${unidade.bairro}, ${unidade.cidade} - ${unidade.uf}`
    },

    baseUrl () {
      return http.defaults.baseURL
    },
    queryParam () {
      let params = {}
      params.servico = 'Exame'
      params.idRede = this.redeExames.rede._id
      if (this.redeExames.exames) {
        params.exames = this.redeExames.exames.map(exame => exame._id)
      }
      return params
    }
  },

  methods: {
    comprar () {
      window.jQuery(`#${this.idModalCompra}`).modal('hide')
      this.$router.push({name: 'Single', query: this.queryParam})
    },
    modalComprar (idModal) {
      this.idModalCompra = idModal
      this.$nextTick(() => {
        window.jQuery(`#${idModal}`).modal('show')
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/orcamento/OrcamentoItem.vue